// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2uHz6","select":"Header_select__13aZr","clinic":"Header_clinic__1ho7v"};